var playVideo = function(){
  var videos = [];

  var _init = function(){
    videos = document.querySelectorAll('[data-film-src]');
    _addEventListeners();
  };

  var _addEventListeners = function(){
    [].map.call(videos, function(video){
      video.addEventListener('click', _createIframe);
    });
  };

  var _createIframe = function(){
    var iframe = document.createElement('iframe');
    iframe.src = this.dataset.filmSrc;
    iframe.frameborder = "0";
    iframe.allowfullscreen;

    this.appendChild(iframe);
  }

  return{
    init: _init
  }
}();

if (document.querySelectorAll('[data-film-src]')) {
  playVideo.init();
}


// WEBPACK FOOTER //
// ./resources/assets/js/partials/EdayPlayVideo.js